import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { FileText, Download } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CredibilityInterviewModal = ({ open, onClose }) => {
  const [materials, setMaterials] = useState([]);

  useEffect(() => {
    if (open) {
      fetchPreparationMaterials();
    }
  }, [open]);

  const fetchPreparationMaterials = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/preparation/materials`);
      setMaterials(response.data);
    } catch (error) {
      console.error('Failed to fetch preparation materials:', error);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading font-semibold text-2xl">Credibility Interview Preparation</DialogTitle>
          <p className="text-muted-foreground">Download materials uploaded by your consultant</p>
        </DialogHeader>

        <div className="space-y-4">
          {materials.length === 0 ? (
            <div className="p-12 text-center">
              <FileText className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">No preparation materials available yet</p>
              <p className="text-sm text-muted-foreground mt-2">Your consultant will upload materials soon</p>
            </div>
          ) : (
            materials.map((material) => (
              <div key={material.id} className="p-4 rounded-xl border bg-card hover:border-primary/50 transition-all">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                        <FileText className="h-5 w-5 text-primary" />
                      </div>
                      <h3 className="font-heading font-semibold text-lg">{material.title}</h3>
                    </div>
                    <p className="text-sm text-muted-foreground ml-13">{material.description}</p>
                    <p className="text-xs text-muted-foreground mt-2 ml-13">
                      Uploaded: {new Date(material.created_at).toLocaleDateString()}
                    </p>
                  </div>
                  <a
                    href={material.file_url}
                    download
                    className="px-4 py-2 rounded-full bg-primary text-white hover:bg-primary/90 transition-all flex items-center gap-2 text-sm font-medium"
                  >
                    <Download className="h-4 w-4" />
                    Download
                  </a>
                </div>
              </div>
            ))
          )}

          <div className="p-4 rounded-xl bg-success/10 border border-success/20 mt-6">
            <h4 className="font-semibold text-success-foreground mb-2">Interview Tips:</h4>
            <ul className="list-disc list-inside space-y-1 text-sm text-success-foreground">
              <li>Review all uploaded materials thoroughly</li>
              <li>Be honest and confident in your responses</li>
              <li>Prepare answers about your course choice and career goals</li>
              <li>Have all your documents ready for reference</li>
            </ul>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CredibilityInterviewModal;